import React from 'react';
import Header from '../components/Header';
const CustomPage = () => {
  return <div className="min-h-screen bg-gray-50" data-id="element-732">
      <Header data-id="element-733" />
      <div className="max-w-7xl mx-auto px-4 py-6" data-id="element-734">
        <div className="bg-white shadow rounded-lg p-6" data-id="element-735">
          <h1 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-736">
            My Custom HTML Page
          </h1>
          {/* Your custom HTML content goes here */}
          <div className="prose" data-id="element-737">
            <p data-id="element-738">
              This is a custom HTML page created within the React application.
            </p>
            <ul data-id="element-739">
              <li data-id="element-740">You can add any HTML elements here</li>
              <li data-id="element-741">You can style them using Tailwind classes</li>
              <li data-id="element-742">You can add interactivity with React hooks</li>
            </ul>
          </div>
        </div>
      </div>
    </div>;
};
export default CustomPage;